import http from '@/utils/http';
import i18n from '@/main';

const baseUrl = '/rastreabilidade/emprestimo';

export default {
    getLoanTotalizer(idArmazem, idProduto, idEmpresaEmprestimo) {
        let url = `${baseUrl}/totalizadores?idArmazem=${idArmazem || 0}&idProduto=${idProduto || 0}&idEmpresaEmprestimo=${idEmpresaEmprestimo || ''}`;

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosEmprestimos')
        });
    },

    buscarEmpresasEmprestimoByArmazem(idArmazem) {
        let url = `${baseUrl}/empresas-por-armazem?idArmazem=${idArmazem}`;

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoEmpresasEmprestimo')
        });
    },

    getLoansPaginatedByFilter(body, page, size, ordenacao) {
        return http.post({
            url: `${baseUrl}/buscar-emprestimos-paginado?page=${page}&size=${size}&sort=${ordenacao}`,
            data: body,
            lockScreen: false
        });
    }
};
